import { Section } from './types';

/**
 * All loan record data recreated from the Salesforce field forms.
 * Field values map 1:1 with the original screens — nothing added or removed.
 */
export const sections: Section[] = [
  {
    id: 'loan-details',
    title: 'Loan Details',
    icon: 'FileText',
    fields: [
      { id: 'loanName', label: 'Loan Name', type: 'text', value: 'Rice, Kathy' },
      { id: 'quickNote', label: 'Quick Note', type: 'textarea', value: 'NEED: HOI, mtg stmt, HOA dues' },
      { id: 'baseLoanAmount', label: 'Base Loan Amount', type: 'currency', value: '292765.00' },
      {
        id: 'typeOfLoan',
        label: 'Type of Loan',
        type: 'select',
        value: 'FHA Streamline',
        options: ['FHA Streamline', 'Conventional', 'VA', 'USDA', 'Jumbo'],
      },
      { id: 'rcmLoanNumber', label: 'RCM Loan Number', type: 'text', value: '2605110013' },
      {
        id: 'loanRecordType',
        label: 'Loan Record Type',
        type: 'select',
        value: 'Refinance',
        options: ['Refinance', 'Purchase'],
        readOnly: true,
      },
      { id: 'stage', label: 'Stage', type: 'select', value: 'P2', options: ['P1', 'P2', 'P3', 'Closing'] },
      {
        id: 'vaDisabilityStatus',
        label: 'VA Disability Status',
        type: 'select',
        value: '',
        options: ['Yes', 'No', 'N/A'],
      },
      {
        id: 'workflowStatus',
        label: 'Workflow Status',
        type: 'select',
        value: 'Borrower Conditions',
        options: ['Borrower Conditions', 'Submitted', 'Approved', 'Clear to Close', 'Funded'],
      },
      { id: 'estimatedAppraisalValue', label: 'Estimated Appraisal Value', type: 'currency', value: '304900.00' },
      {
        id: 'leadSource',
        label: 'Lead Source',
        type: 'select',
        value: 'Telemarketing',
        options: ['Telemarketing', 'Referral', 'Web', 'Repeat Client'],
      },
      { id: 'expectedPrice', label: 'Expected Price', type: 'number', value: '100.250' },
      { id: 'totalLoanAmount', label: 'Total Loan Amount', type: 'currency', value: '297888.00' },
      {
        id: 'mortgageType',
        label: 'Mortgage Type',
        type: 'select',
        value: 'Fixed',
        options: ['Fixed', 'ARM'],
      },
      { id: 'interestRate', label: 'Interest Rate', type: 'percent', value: '5.750' },
      {
        id: 'refinancePurpose',
        label: 'Refinance Purpose',
        type: 'select',
        value: 'FHA Streamline',
        options: ['FHA Streamline', 'Cash Out', 'Rate & Term'],
      },
      { id: 'estCloseDate', label: 'Est Close Date', type: 'date', value: '' },
      {
        id: 'occupancy',
        label: 'Occupancy',
        type: 'select',
        value: 'Primary Residence',
        options: ['Primary Residence', 'Second Home', 'Investment'],
      },
      { id: 'ltv', label: 'LTV', type: 'percent', value: '97.700' },
      {
        id: 'propertyType',
        label: 'Property Type',
        type: 'select',
        value: 'Detached',
        options: ['Detached', 'Attached', 'Condo', 'Townhome'],
      },
      {
        id: 'loanPurpose',
        label: 'Loan Purpose',
        type: 'select',
        value: 'Refinance',
        options: ['Refinance', 'Purchase'],
      },
      { id: 'investor', label: 'Investor', type: 'text', value: 'Planet' },
      { id: 'term', label: 'Term', type: 'number', value: '30' },
      { id: 'investorLoanNumber', label: 'Investor Loan Number', type: 'text', value: '9102594388' },
      { id: 'fico', label: 'FICO', type: 'number', value: '650' },
      { id: 'ausRan', label: 'AUS Ran', type: 'text', value: 'N/A (Streamline)' },
      { id: 'waiveEscrow', label: 'Waive Escrow', type: 'select', value: 'No', options: ['Yes', 'No'] },
      { id: 'affordable', label: 'Affordable', type: 'select', value: '', options: ['Yes', 'No'] },
      {
        id: 'floatLeDisclosed',
        label: 'Was a Float LE Already Disclosed?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
      },
      { id: 'applicationDate', label: 'Application Date', type: 'date', value: '2026-05-12' },
      { id: 'titleCompany', label: 'Title Company', type: 'text', value: 'Cosmo' },
      {
        id: 'rateLockAtReg',
        label: 'Rate Lock at Reg',
        type: 'select',
        value: 'Lock',
        options: ['Lock', 'Float'],
      },
      { id: 'titleCompanyName', label: 'Title Company Name', type: 'text', value: 'COSMO' },
      { id: 'numberOfUnits', label: 'Number of Units', type: 'number', value: '1' },
      { id: 'orderAppraisal', label: 'Order Appraisal', type: 'text', value: '' },
      {
        id: 'appraisalType',
        label: 'Appraisal Type',
        type: 'select',
        value: 'N/A',
        options: ['N/A', 'Full', 'Drive-by', 'Desktop'],
      },
      { id: 'secondMortgage', label: 'Second Mortgage', type: 'select', value: 'No', options: ['Yes', 'No'] },
      { id: 'appraisalPayment', label: 'Appraisal Payment', type: 'currency', value: '' },
      { id: 'loanSaver', label: 'LoanSaver', type: 'text', value: '' },
      {
        id: 'addingRemovingTitle',
        label: 'Adding or Removing Individual on Title?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
        hint: 'Indicates a change to the individuals listed on the property title.',
      },
      { id: 'optOutDate', label: 'Opt Out Date', type: 'date', value: '' },
      { id: 'closeCurrentMonth', label: 'Close Current Month', type: 'checkbox', value: false },
      { id: 'earliestCloseDate', label: 'Earliest Close Date', type: 'date', value: '2026-06-05' },
      { id: 'processingComments', label: 'Processing Comments', type: 'textarea', value: '' },
      { id: 'estimatedFirstPaymentDate', label: 'Estimated First Payment Date', type: 'date', value: '' },
      { id: 'rcmMonthSubmitted', label: 'RCM Month Submitted', type: 'text', value: 'April 26' },
      { id: 'isReDoc', label: 'Is This a Re Doc?', type: 'checkbox', value: false },
      { id: 'prepaymentPenalty', label: 'Prepayment Penalty', type: 'text', value: '' },
      { id: 'regToDisclose', label: 'Reg to Disclose', type: 'select', value: 'Yes', options: ['Yes', 'No'] },
      { id: 'closingInLlc', label: 'Closing in LLC', type: 'select', value: '', options: ['Yes', 'No'] },
    ],
  },
  {
    id: 'subject-property',
    title: 'Subject Property',
    icon: 'Home',
    fields: [
      { id: 'propertyAddress', label: 'Subject Property Address', type: 'text', value: '362 Tumbleweed Pl' },
      { id: 'propertyCounty', label: 'Subject Property County', type: 'text', value: 'Charles' },
      { id: 'propertyCity', label: 'Subject Property City', type: 'text', value: 'Waldorf' },
      { id: 'propertyState', label: 'Subject Property State', type: 'text', value: 'MD' },
      { id: 'propertyZip', label: 'Subject Property Zip Code', type: 'text', value: '20601' },
    ],
  },
  {
    id: 'contact-information',
    title: 'Contact Information',
    icon: 'UserRound',
    fields: [
      { id: 'accountName', label: 'Account Name', type: 'user', value: 'Kathy Rice' },
      { id: 'isCoBorrower', label: 'Is There a Co-Borrower?', type: 'select', value: 'No', options: ['Yes', 'No'] },
      {
        id: 'isNbsTitleHolder',
        label: 'Is There a NBS/Additional Title Holder?',
        type: 'select',
        value: 'No',
        options: ['Yes', 'No'],
      },
      { id: 'coBorrowerFirstName', label: 'Coborrower First Name', type: 'text', value: '' },
      { id: 'coBorrowerLastName', label: 'CoBorrower Last Name', type: 'text', value: '' },
      { id: 'coBorrowerEmail', label: 'CoBorrower Email', type: 'text', value: '' },
    ],
  },
  {
    id: 'user-information',
    title: 'User Information',
    icon: 'Users',
    fields: [
      { id: 'loanOfficer', label: 'Loan Officer', type: 'user', value: 'Raymond Happel' },
      { id: 'team', label: 'Team', type: 'text', value: 'The Bullpen' },
      { id: 'manager', label: 'Manager', type: 'user', value: 'Taylor Bishop' },
      { id: 'cds', label: 'CDS', type: 'text', value: '' },
      { id: 'p1Concierge', label: 'P1/Concierge', type: 'user', value: 'Kayla Harrington' },
      { id: 'jrLo', label: 'JR LO', type: 'text', value: '' },
      { id: 'p2', label: 'P2', type: 'user', value: 'Lauren Eddy' },
      { id: 'jrLoManager', label: 'JR LO Manager', type: 'text', value: '' },
      { id: 'feeMaster', label: 'Fee Master', type: 'text', value: '' },
      { id: 'loa', label: 'LOA', type: 'text', value: '' },
      { id: 'docMaster', label: 'Doc Master', type: 'text', value: '' },
      { id: 'lockMaster', label: 'Lock Master', type: 'user', value: 'Nikki Borchers' },
      { id: 'hoiOrderedBy', label: 'HOI Ordered By', type: 'user', value: 'Miranda Oehler' },
      { id: 'disclosureMaster', label: 'Disclosure Master', type: 'text', value: '' },
      { id: 'titleOrderedBy', label: 'Title Ordered By', type: 'user', value: 'Miranda Oehler' },
      { id: 'icdSpecialist', label: 'ICD Specialist', type: 'text', value: '' },
      { id: 'appraisalOrderedBy', label: 'Appraisal Ordered By', type: 'text', value: '' },
    ],
  },
];
